import { SelectionSet } from "utils/selectionSet";

/**
 * True if `current` differs from `previous`. withX() ops on SelectionSet
 * return the same instance when nothing actually changed, so reference
 * equality is checked first; the elementwise fallback covers cases (e.g.
 * SetIds) that always construct a fresh SelectionSet even with identical ids.
 */
export function hasSelectionSetChanged(current: SelectionSet, previous: SelectionSet): boolean {
    if (current === previous) {
        return false;
    }
    return current.size !== previous.size || current.sortedIds.some((id, i) => id !== previous.sortedIds[i]);
}

/**
 * Ids added/removed between two selections. Uses SelectionSet.has() (binary
 * search/bitset) instead of building intermediate Sets, which matters for
 * full-scene selections (~1.25M ids).
 */
export function diffSelectionSets(
    next: SelectionSet,
    prev: SelectionSet,
): { added: Uint32Array; removed: Uint32Array } {
    return {
        added: next.sortedIds.filter((id) => !prev.has(id)),
        removed: prev.sortedIds.filter((id) => !next.has(id)),
    };
}
